// BOL Email Constants

export const EMAIL_VALIDATION = {
  MAX_LENGTH: 900,
  SUBJECT_MAX_LENGTH: 100,
  REGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
} as const;

export const FILE_SIZE_UNITS = ["B", "KB", "MB", "GB"] as const;

export enum EMAIL_TYPES {
  Disposition = "Disposition",
  MSD_BOL_GENERATED = "MSD_BOL_GENERATED",
  MSD_BOL_REGENERATED = "MSD_BOL_REGENERATED",
  MSD_BOL_UPDATED_AND_REGENERATED = "MSD_BOL_UPDATED_AND_REGENERATED",
  HAZMAT_BOL_APPROVAL_REQUEST = "HAZMAT_BOL_APPROVAL_REQUEST",
  MSD_BOL_UPDATED_APPROVAL_REQUEST = "MSD_BOL_UPDATED_APPROVAL_REQUEST",
}

export const BOL_EMAIL_TYPE_STORAGE_KEY_PREFIX = "msd_bol_email_type_";

export const getBolEmailTypeStorageKey = (osdNumber: string): string =>
  `${BOL_EMAIL_TYPE_STORAGE_KEY_PREFIX}${osdNumber}`;

export const EMAIL_TEMPLATE = `
  <img src="{{logoBase64}}" alt="Logo" />
  <p>&nbsp;</p>
  <p> {{date}}, </p> 
  <div style="line-height: 1; margin: 0; padding: 0;">
  {{businessName}}<br>
  {{address}}<br>
  {{cityStateZip}}
  </div>
  <p> PICKUP Number: <b>{{pickupNumber}}</b></p> 
  <p> Dear Valued Customer, </p> 
  <p>We are writing to inform you that a pickup has been scheduled at your location for product that was inadvertently delivered to you. We sincerely appreciate your cooperation and assistance in returning this order to our SAIA terminal. Should there be any issues during the pickup process or if a rescheduling is necessary, please email us at osdclp@saia.com.</p> 
  
  <p>At the time of pickup, please present the Bill of Lading attached to this email to the pickup driver. Additionally, please attach another copy of the Bill of Lading to the product that was misdelivered.</p> 

  <p>We apologize for any inconvenience this may have caused your company. We highly value your business and are committed to working diligently to resolve this matter promptly.</p>
  
  <p>Thank you for your understanding and for choosing SAIA for your shipping needs.</p>`;

export const ERROR_MESSAGES = {
  REQUIRED: "Email is required",
  MAX_LENGTH: "Email address length should not exceed 900 characters",
  INVALID: "Invalid email address",
  FETCH_ERROR: "Error fetching misdelivery details",
  SEND_ERROR: "Error sending mail",
  BOL_SEND_ERROR: "Error sending BOL mail",
  SEND_SUCCESS: "Email sent successfully",
  BOL_SEND_SUCCESS: "BOL email sent successfully",
} as const;
